import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    SxProps,
    Theme,
    Typography,
    TypographyProps,
} from '@mui/material';
import { ReactNode } from 'react';
import { IPopUp } from './hooks/usePopUp';

type Props = IPopUp & {
    title?: ReactNode;
    subTitle?: ReactNode;
    desc: ReactNode;
    fixOverflow?: boolean;
    minWidthButton?: number;
    subTitleProps?: TypographyProps;
    contentProps?: SxProps<Theme>;
    titleProps?: SxProps<Theme>;
    hideTitle?: boolean;
};

export default function PopUpBase(props: Props) {
    return (
        <Dialog {...props.dialogProps} open={props.open}>
            {!props.hideTitle && (
                <DialogTitle
                    component={Stack}
                    sx={{ ...props.titleProps, textAlign: 'center', alignItems: 'center', width: '100%' }}
                >
                    {typeof props.title === 'string' ? (
                        <Typography variant="h4">{props.title}</Typography>
                    ) : (
                        props.title
                    )}

                    {typeof props.subTitle === 'string' ? (
                        <Typography color="success.main" variant="body1" {...props.subTitleProps}>
                            {props.subTitle}
                        </Typography>
                    ) : (
                        props.subTitle
                    )}
                </DialogTitle>
            )}
            <DialogContent sx={{ ...props.contentProps, overflowY: props.fixOverflow ? 'unset' : undefined }}>
                {props.desc}
            </DialogContent>
            {!(props.hideClose && props.hideConfirm) && (
                <DialogActions
                    {...props.dialogActionsProps}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        '& button': {
                            minWidth: props.minWidthButton || 200,
                        },
                        px: 3,
                        pb: 3,
                        ...props.dialogActionsProps?.sx,
                    }}
                >
                    {props.customActions ? (
                        props.customActions
                    ) : (
                        <>
                            {!props.hideClose && (
                                <Button variant="cancel" onClick={props.onClose}>
                                    Close
                                </Button>
                            )}
                            {!props.hideConfirm && (
                                <Button variant="contained" onClick={props.onConfirm}>
                                    Save
                                </Button>
                            )}
                        </>
                    )}
                </DialogActions>
            )}
        </Dialog>
    );
}
